<ng-template #detailRow let-incident>
  <div style="overflow: hidden;display: flex;">
    <div style="width: 100%">
      <button mat-button (click)="viewNIBINBallisticsReport(incident.IncidentID)">
        <mat-icon>picture_as_pdf</mat-icon> NIBIN Ballistics Report
      </button>

      <button mat-button (click)="viewNJPOPReport(incident.NJPopNo)" *ngIf="incident.NJPopNo" [matTooltip]="'Download NJPOP# '+ incident.NJPopNo">
        <mat-icon>picture_as_pdf</mat-icon> NJPOP Incident Report #{{incident.NJPopNo}}
      </button>

      <button mat-button (click)="TransferOwnership(incident)" *ngIf="this.user.CurrentDept?.toLowerCase()==incident.Lab?.toLowerCase()">
        <mat-icon>move_down</mat-icon> TRANSFER OWNERSHIP
      </button>

      <button mat-button (click)="ViewIncidentChangeHistory(incident)" *ngIf="this.user.CurrentDept?.toLowerCase()==incident.Lab?.toLowerCase()">
        <mat-icon>history</mat-icon> VIEW CHANGE HISTORY
      </button>

      <button mat-button (click)="ShareEditLink(incident)" *ngIf="this.user.CurrentDept?.toLowerCase()==incident.Lab?.toLowerCase()">
        <mat-icon>dataset_linked</mat-icon> SEND UPDATE REQUEST
      </button>

      <button mat-button (click)="DeleteIncident(incident)" *ngIf="this.user.CurrentDept?.toLowerCase()==incident.Lab?.toLowerCase() && (incident.Reports == null ||incident?.Reports?.length === 0 )">
        <mat-icon>delete</mat-icon> DELETE INCIDENT
      </button>

      <div style="width: 100%; display: flex;">
        <mat-card style="margin: 3px; width: 50%;" class="mat-elevation-z2">
          <table style="width: 100%;">
            <thead >
            <tr>
              <th style="text-align: left;">Type</th>
              <th style="text-align: left">Details</th>
              <th style="text-align: left"></th>
            </tr>
            </thead>
            <tbody>

            <tr *ngFor="let weapon of incident.Weapon">

              <td>Weapon</td>
              <td style="text-align: left">
                {{weapon.CALIBER}}&nbsp;
                {{weapon.MAKE}}&nbsp;
                {{weapon.W_CLASS}}&nbsp;
                {{weapon.MODEL}}&nbsp;
                <span *ngIf="weapon.SERIAL_NUMBER">&nbsp;Serial# {{weapon.SERIAL_NUMBER}}</span>
                <span *ngIf="weapon.EvidenceMarker">&nbsp;({{weapon.EvidenceMarker}})</span>
                <span *ngIf="weapon.Notes">&nbsp; Notes: ({{weapon.Notes}})</span>
              </td>
              <td><!--Actions--></td>
            </tr>

            <tr *ngFor="let b of incident.Ballistics">
              <td>{{b.Item_Type}}</td>
              <td style="text-align: left">
                ({{b.Item_Quantity}})&nbsp;
                {{b.Caliber_Type}}&nbsp;
                {{b.Headstamp}}&nbsp;
                Discharged {{b.VGID_CPart}}&nbsp;
                <span *ngIf="b.EvidenceMarker">&nbsp;({{b.EvidenceMarker}})</span>
                <span *ngIf="b.Notes">&nbsp;Notes: ({{b.Notes}})</span>
              </td>
              <td><!--Actions--></td>
            </tr>


            </tbody>
          </table>
        </mat-card>

        <mat-card style="margin: 3px; width: 50%;" class="mat-elevation-z2">
          <table style="width: 100%;">
            <thead >
            <tr>
              <th style="text-align: left;">Lab</th>
              <th style="text-align: left">Reference Number</th>
              <th style="text-align: left">Report Date</th>
              <th style="text-align: left">Actions</th>
            </tr>
            </thead>
            <tbody>

            <tr *ngFor="let report of incident.Reports">
              <td>{{report.Lab}}</td>
              <td>{{report.ReferenceNumber}}</td>
              <td>{{report.EnteredDateTime | date:'MM-dd-yyyy'}}</td>
              <td><button mat-button (click)="viewNIBINReport(report.ReportID)">View/Download PDF</button></td>
            </tr>


            </tbody>
          </table>
        </mat-card>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #PersonDetailRow let-incident>
  <ul>
    <li *ngFor="let person of incident.Persons">
      <span *ngIf="person.Role">({{person.Role[0]}})</span> <span *ngIf="person.Rank"> {{person.Rank}}</span> {{ person.FIRSTNAME }} {{person.LASTNAME}}
    </li>
  </ul>
</ng-template>

<ng-template #ActionDetailRow let-incident>
  <button mat-icon-button (click)="editIncidentDialog(incident)" *ngIf="this.user.CurrentDept?.toLowerCase()==incident.Lab?.toLowerCase()"><mat-icon>edit</mat-icon></button>
</ng-template>

<ng-template #SelectDetailRow let-incident>
  <button mat-icon-button (click)="SelectedForReport(incident)" matTooltip="Import Incident into Report">
    <mat-icon *ngIf="!incident.SelectedForReport">add</mat-icon>
    <mat-icon *ngIf="incident.SelectedForReport">remove</mat-icon>
  </button>
</ng-template>

<ng-template #OccurrenceDateTPL let-incident>
  {{incident.OccurrenceDate | date:'MM-dd-yyyy'}}
</ng-template>

<ejs-grid
  #incidentsGrid
  style="margin-top: 10px;"
  [dataSource]='dataSource2'
  [allowPaging]="true"
  [allowSorting]="true"
  [allowFiltering]="true"
  [detailTemplate]="detailRow"
  [filterSettings]="{type: 'Excel'}"
  [allowTextWrap]="true"
  [textWrapSettings]="{ wrapMode: 'Both' }"
  [pageSettings]="{pageSize:25}"
>
  <e-columns>
    <e-column [template]="SelectDetailRow" headerText='' *ngIf="showAdd"></e-column>
    <e-column field='Lab' headerText='Lab'></e-column>
    <e-column [template]='OccurrenceDateTPL' field='OccurrenceDate' headerText='Occurrence Date' [allowFiltering]="false"></e-column>
    <e-column field='LabNumber' headerText='LabNumber'></e-column>
    <e-column field='Inc_Type' headerText='Type' [allowFiltering]="false"></e-column>
    <e-column field='Inc_RelatedArea' headerText='Event Type' [allowFiltering]="false"></e-column>
    <e-column field='Dept' headerText='Agency'></e-column>
    <e-column field='CaseNumber' headerText='Case Number'></e-column>
    <e-column field='Inc_Location' headerText='Location'></e-column>
    <e-column field='Inc_City' headerText='City'></e-column>
    <e-column [template]="PersonDetailRow" headerText='Persons'></e-column>
    <e-column [template]="ActionDetailRow" headerText='Actions'></e-column>
  </e-columns>
</ejs-grid>
